<template>
  <b-modal id="modal_assign_locations_to_products" title="Asignación de ubicaciones" scrollable>

    <b-alert show variant="primary" class="">
      <i class="fa fa-info-circle"/>  Total productos <b>{{ products_ids.length }}</b>
    </b-alert>

    <b-form-group>
      <label for="bases"><b>Ubicaciones</b></label>
      <br/>

      <el-tree
        @check-change="handleCheckChange"
        :data="arbolUbicaciones"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="tree"
        highlight-current
        :default-checked-keys="selecionadosIds"
        :filter-node-method="filterNode"
      />

    </b-form-group>

    <template #modal-footer="{ ok, cancel, hide }">
      <b-button @click="cancel()"> Cancelar</b-button>
      <b-button :disabled="!selecionadosIds.length"
                variant="primary"
                @click="saveLocationstoPr()">
        Guardar
      </b-button>
    </template>


  </b-modal>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import Swal from "sweetalert2";

export default {
  props: ['products_ids'],
  name: "ModalAssignLocationProducts",
  components: {
    Treeselect,
  },
  data() {
    return {
      payload: {
        locations: [],
        products_ids: []
      },
      selecionadosIds: [],
      initialSelection: [],
    }
  },
  methods: {
    ...mapActions('productos_emp', ['addLocationsToProducts']),
    normalizer(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    /**
     * @description: Metodo para obtener las ubicaciones de un producto
     * @param {Object} data
     * @return: void
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    async saveLocationstoPr() {
      this.payload.products_ids = this.products_ids;
      this.payload.locations = this.selecionadosIds;
      this.payload.company_id = this.$route.params.id;
      await this.addLocationsToProducts(this.payload).then(async ({message})=>{
        this.$bvModal.hide('modal_assign_locations_to_products');
        await Swal.fire({
          position: 'center',
          icon: 'success',
          title: message,
          showConfirmButton: false,
          timer: 2000
        });
        await this.$emit('resetProductsIds',true)
      });
    },
    /**
     * @description: Metodo de cambio de estado de un check
     * @param {Object} data
     * @return: void
     */
    handleCheckChange(data, checked) {
      if (!checked) {
        this.initialSelection = this.initialSelection;
      }
      if (this.selecionadosIds.includes(data.id) && !checked) {
        this.selecionadosIds.forEach(function (item, index, object) {
          if (item === data.id) {
            object.splice(index, 1);
          }
        });
      }

      if (checked && !this.selecionadosIds.includes(data.id)) {
        this.selecionadosIds.push(data.id);
      }
    },
  },
  computed: {
    ...mapState('productos', ['ubicEmpresa', 'arbolUbicaciones']),
  }
}
</script>

<style scoped>

</style>
<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>
